import { createSwitch } from "./createSwitch.mjs";
import { SwitchFrame, SwitchThumb } from "./Switch.mjs";
export * from "./createSwitch.mjs";
export * from "./StyledContext.mjs";
export * from "./Switch.mjs";
const Switch = createSwitch({
  Frame: SwitchFrame,
  Thumb: SwitchThumb
});
export { Switch };
//# sourceMappingURL=index.mjs.map
